// Pure helpers for the day screen. Separate from the components so the numbers
// can be pinned without mounting anything.
import { MEALS } from "@common/schema/entry/fields";

export { MEALS };

export const MEAL_LABELS = {
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  snack: "Snacks",
};

// One group per meal, in the order a day is eaten, EVERY meal present — an
// empty lunch is a heading with an Add link under it, which is where the next
// thing gets logged. Within a meal, the order things were logged in.
export const byMeal = (entries = []) =>
  MEALS.map((meal) => {
    const items = entries
      .filter((e) => e.meal === meal)
      .sort((a, b) => String(a.createdAt).localeCompare(String(b.createdAt)));
    const calories = items.reduce((acc, e) => acc + Number(e.calories || 0), 0);
    return { meal, label: MEAL_LABELS[meal], items, calories: Math.round(calories) };
  });

// Energy from each macro, as a share of the energy the three macros account
// for — 4 kcal/g protein and carbs, 9 kcal/g fat. Out of the macros' own sum
// rather than the logged calories, so the three always add to 100 even when
// a label's calories and its macros disagree, which they routinely do.
export const macroSplit = ({ protein = 0, carbs = 0, fat = 0 } = {}) => {
  const kcal = { protein: protein * 4, carbs: carbs * 4, fat: fat * 9 };
  const sum = kcal.protein + kcal.carbs + kcal.fat;
  if (!sum) return { protein: 0, carbs: 0, fat: 0 };
  const protein_ = Math.round((kcal.protein / sum) * 100);
  const carbs_ = Math.round((kcal.carbs / sum) * 100);
  // The remainder, so rounding never makes the bar 99 or 101 wide.
  return { protein: protein_, carbs: carbs_, fat: 100 - protein_ - carbs_ };
};

export const formatNumber = (value, digits = 0) =>
  Number(value || 0).toLocaleString([], { maximumFractionDigits: digits });
